<div>
  <div class="flex">
    <custom-label *ngIf="placeholder" [placeholder]="placeholder"></custom-label>
    <div *ngIf="isRequired" class="text-red-500 ml-1 mt-1">*</div>
  </div>
  <p-dropdown
    [options]="data"
    [optionLabel]="label"
    [filter]="filterBy ? true : false"
    [filterBy]="filterBy"
    [placeholder]="dropdownMessage"
    [formControl]="value"

  ></p-dropdown>
</div>

